export * from './documentStandardEntriesDropDown.service';
import { DocumentStandardEntriesDropDownService } from './documentStandardEntriesDropDown.service';
export * from './employeeDocument.service';
import { EmployeeDocumentService } from './employeeDocument.service';
export * from './forms.service';
import { FormsService } from './forms.service';
export * from './notification.service';
import { NotificationService } from './notification.service';
export const APIS = [DocumentStandardEntriesDropDownService, EmployeeDocumentService, FormsService, NotificationService];
